// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guestbox[data-v-783be295]{margin:0 auto;line-height:46px;text-align:left;font-size:15px;color:#676767}.gb-td[data-v-783be295]{padding:8px 12px}.gb-td.label[data-v-783be295]{line-height:1}.age[data-v-783be295]{font-size:14px;padding-top:5px}.btn[data-v-783be295]{width:48px;height:48px;line-height:1;border-radius:50%;font-size:30px;padding:4px}.label[data-v-783be295]{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
